import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Form, Link, useLocation, useNavigate } from 'react-router-dom';
import jwt_decode from "jwt-decode";
import Navbar from "../../Navbar";
import Header from "../../Header";
import baseUrl from "../../BaseUrl";
import Loader from "../../Loader";
import { use } from 'react';

const NO_PAGINATION_LIMIT = 10000;

const ImportCallPassDiridTn = () => {

    const navigate = useNavigate();
    const location = useLocation();
    
    const { initialFilters } = location.state || {};
    

    const [name, setName] = useState('');
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    const [role, setRole] = useState('');
    const [access, setAccess] = useState([]);
    const [cid, setCid] = useState('');

    const [loadingCount, setLoadingCount] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const [companyList, setcompanyList] = useState([]);
    const [displayIdentities, setDisplayIdentities] = useState([])
    const [formData, setFormData] = useState({
        company: initialFilters?.selectedCompany || '',
        operation: 'A',
        displayIdentityIndex: '',
        file: ''
    });
    const [validationErrors, setValidationErrors] = useState({
        company: false,
        displayIdentityIndex: false,
        file: false,
    });
    const [importDisabled, setImportDisabled] = useState(false);

    const incrementLoading = () => setLoadingCount((prev) => prev + 1);
    const decrementLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));

    useEffect(() => {
        setPopupOpen(loadingCount > 0);
    }, [loadingCount]);

    useEffect(() => {
        refreshToken();
    }, []);

    useEffect(() => {
        if(token){
            getCustomerNameList();
        } 
    }, [token]);   

    useEffect(() => {
        if(cid){
            checkPageAccess();
        }
    }, [cid]);
    useEffect(() => {
        if(role > 2){
            setFormData({ ...formData,  company: cid, displayIdentityIndex: '' });
            fetchDisplayIdentitiesData(1, cid);
        }
    },[role]);

useEffect(() => {
    setPopupOpen(loadingCount > 0);
}, [loadingCount]);

    useEffect(() => {
        fetchDisplayIdentitiesData(1, formData.company);
    },[formData.company])

    const axiosJWT = axios.create();
 
    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setCid(decoded.cid);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);
            
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setCid(decoded.cid);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);

        } catch (error) {
            if (error.response) {
                navigate("/");  
                window.location.reload();
            }
        }
    }


    const getCustomerNameList = async () => {
        try {
          
            const response = await axios.get(`${baseUrl}/active-user-company`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
            const allArray = response.data.filter(item => item.id !== 1);
            setcompanyList(allArray);
            
        } catch (error) {
           console.log(error);
            
        }
    };

   const checkPageAccess = async () => {
        try {
            incrementLoading();
            // Fetch all required data            
            const customerDigitMappingResponse = await axios.get(`${baseUrl}/check-company-e911-access/${cid}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            const userAccessResponse = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            
            const callPassDisplayIdentitiesSwitch = customerDigitMappingResponse.data.call_pass_display_identities_switch;
            const userCallPassDisplayIdentitiesSwitch = userAccessResponse.data.user_call_pass_display_identities_switch;
            decrementLoading();
            setAccess(userAccessResponse.data.results);
            // Conditional check for access
            if (
                callPassDisplayIdentitiesSwitch >= 1 &&
                userCallPassDisplayIdentitiesSwitch >= 1
            ) {
                console.log("Access granted to Import Call Pass Display Identity History page");
                // Proceed with page logic
            } else {
                navigate('/dashboard');
            }
        } catch (error) {
            console.error("Error checking page access:", error);
            navigate('/dashboard'); // Redirect in case of any error
        }
    };

    const handleCompanyChange = (e) => {
        setFormData({ ...formData,  company: e.target.value, displayIdentityIndex: '' });
    }; 

    const handleDisplayIdentityChange = (e) => {
        setFormData({ ...formData, displayIdentityIndex: e.target.value});
    }; 

    const handleOperationChange = (e) => {
        setFormData({...formData, operation: e.target.value})
    }

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFormData({...formData, file: selectedFile})
    };

    const fetchDisplayIdentitiesData = async (page, company) => {
        incrementLoading();
        try {
            // TODO: Replace with actual API endpoint and payload
            const response = await axiosJWT.get(`${baseUrl}/call-pass-display-identities`, {
                params: { 
                    page: 1,
                    limit: NO_PAGINATION_LIMIT, 
                    company: company,
                },
                headers: { Authorization: `Bearer ${token}` }
            });
            setDisplayIdentities(response.data.summary || []);
        } catch (error) {
            console.error("Error fetching summary data:", error);
            // Handle error
        } finally {
            decrementLoading();
        }
    };

    const handleImport = async (e) => {
        e.preventDefault();
        const newValidationErrors = {
            company: formData.company == '',
            displayIdentityIndex: formData.displayIdentityIndex == '',
            file: formData.file == ''
        };
        console.log(formData, "formdata");
        setValidationErrors(newValidationErrors);
        const hasErrors = Object.values(newValidationErrors).some((error) => error);

        if(!hasErrors){
            setImportDisabled(true)
            setPopupOpen(true)

            const displayIdentity = displayIdentities[formData.displayIdentityIndex]

            const newData = new FormData()
            newData.append('company', formData.company)
            newData.append('eid',displayIdentity.eid)
            newData.append('dirid', displayIdentity.dirid)
            newData.append('operation', formData.operation)
            newData.append('file', formData.file)

            axios.post(`${baseUrl}/import-call-pass-dirid-tn`, newData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                }
            })

            navigate('/order-new-number-success', {
                state: {
                    importCallPassDiridTn: true
                }
            }) 
            setPopupOpen(false)
        }
    }




  return (
    <div className="panelbox">
        <Navbar  token={token} access = {access}/>
        <div className="right-panel">
            <Header name={name} />
            {popupOpen && <Loader />}
            <div className="content-page">
                <>
                    <div className="row">
                        <div className="col-8">
                            <div className="left-title">
                                <h1>Import Call Pass Display Identity</h1>
                            </div>
                        </div>

                        <div className="col-4 top-right-buttons">   
                            <div className="export-btn addnew-button"><Link to="/import-call-pass-dirid-tn-history">History</Link></div>
                            <div className="export-btn addnew-button"><Link to="/call-pass-display-identities" state={{ initialFilters: { selectedCompany: formData.company } }}><span>&larr;</span> Back</Link></div>
                        </div>  
                    </div>

                    {role <=2 && <div className="common-white-shadow-background setting-section">
                        <div className="row">
                            <h3 className='comapny-label'>Select Company</h3>
                            <div className="inputbox">
                                <select name="" id=""  value={formData.company} onChange={(e) => handleCompanyChange(e)}>
                                    <option value="">Select Company</option>
                                    {companyList.map((comp) => (                                                                    
                                        <option key={comp.id} value={comp.id}>
                                            {comp.cname}
                                        </option>  
                                    ))}
                                </select>
                            </div>
                        </div>
                        {validationErrors.company && <p className="error">Please select a value from the dropdown.</p>}
                    </div>}

                    <div className="common-white-shadow-background setting-section">
                        <div className="row">
                            <h3 className='comapny-label'>Select Display Identity</h3>
                            <div className="inputbox">
                                <select name="" id=""  value={formData.displayIdentityIndex} onChange={(e) => handleDisplayIdentityChange(e)}>
                                    <option value="">Select Display Identity</option>
                                    {displayIdentities.map((identity, index) => (                                                                    
                                        <option key={index} value={index}>
                                            {`${identity.entity_name ? identity.entity_name + ' - ' : ''}${identity.display_name}-${identity.call_reason}-${identity.logo}`}
                                        </option>  
                                    ))}
                                </select>
                            </div>
                        </div>
                        {validationErrors.displayIdentityIndex && <p className="error">Please select a value from the dropdown.</p>}
                    </div>

                    <div className="common-white-shadow-background setting-section">
                        <div className="row">
                            <h3 className='comapny-label'>Operation</h3>
                            <div className="settingbox radio-standard-box">
                                <label htmlFor="add">
                                    <input 
                                        type="radio" 
                                        id="pastNumber"
                                        name="operation"  
                                        value={'A'} 
                                        checked={formData.operation === 'A'} 
                                        onChange={handleOperationChange} 
                                    />
                                        Add
                                </label>

                                <label htmlFor="delete">
                                    <input 
                                        type="radio" 
                                        id="pastNumber" 
                                        name="operation"  
                                        value={'D'} 
                                        checked={formData.operation === 'D'} 
                                        onChange={handleOperationChange} 
                                    />
                                        Delete
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="common-white-shadow-background setting-section">
                        <div className="row">
                            <h3>Upload File (Using Template)</h3>
                            <div className="download-templte">
                                <a className="newrow" target="_blank" href={`${process.env.PUBLIC_URL}/template/Import_Call_Pass_DI_Tn.xlsx`} download="Import_Call_Pass_DI_Tn.xlsx">Download Template</a><p>Submissions must be in the format of this template</p>
                            </div>
                            <div className="file-upload-field">
                                <div className="upload-btn-wrapper">
                                    <input type="file" name="myfile" onChange={handleFileChange} placeholder="Select your local file based on our template" />
                                </div>
                            </div>
                        </div>
                        {validationErrors.file && (<p className="error">Please choose a file.</p>)}
                    </div>
                    
                    <div className="row footer-row">
                        {/* <a href="#" className="Cancel">Cancel</a> */}
                        <a href="#" className={importDisabled ? 'next disabled-link' : 'next'} onClick={handleImport}>Import</a>
                    </div>
                </>
            </div>
        </div>
    </div>
  )
}

export default ImportCallPassDiridTn